import React, { useState, useEffect, useContext } from 'react';
import { Button, Input, Label } from 'semantic-ui-react';
import './style.less';
import queryString from 'query-string';

const SSOAlexaUser = (props) => {
    const [firstName, setFirstName] = useState();

    useEffect(() => {
        const { params } = queryString.parse(props.location.search);
        const paramsObj = params && atob(params) && JSON.parse(atob(params));
        console.log(paramsObj);
        setFirstName(paramsObj.residentName);
    }, [props.location.search]);

    return (
        <div className="sso-container">
            <div className="content-disp">
                <div>
                    <Input
                        type="text"
                        value={firstName}
                        className="input"
                        placeholder="FirstName"
                        onChange={(e) => setFirstName(e.target.value)}
                    ></Input>
                </div>

                <div className="input">
                    <Button
                        disabled={!firstName}
                        onClick={() => {
                            const state = btoa(`name:${firstName}`);

                            const hostname = window.location.hostname;
                            const redirect_uri = `https://${hostname}/sso-redirect`;

                            const url = `https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.cec7f0739d0c48929547c0965562f5b3&scope=alexa::skills:account_linking&response_type=code&redirect_uri=${redirect_uri}&state=${state}`;

                            window.location.href = url;
                        }}
                    >
                        SSO
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SSOAlexaUser;
